module.exports = new __parcel__URL__("shop_available_button.aef96c93.png").toString();